import React, { useState } from 'react';
import PreviewImage from '../image-preview';
import UploadImage from '../upload-image';

interface IProps {
  previewImage: string;
  setPreviewImage: any;
  setFieldValue: any;
  label?: string;
  name?: string;
  isHidden?: any;
  setIsHidden?: any;
  required?: string;
}

const ImageUploadWithPreview: React.FC<IProps> = ({
  name,
  required,
  previewImage,
  setPreviewImage,
  setFieldValue,
  label,
  isHidden,
  setIsHidden,
}) => {
  const handleChange = (file: any) => {
    setPreviewImage(file === null ? '' : file);
    setFieldValue('image', file === null ? '' : file);
  };

  return (
    <>
      {previewImage ? (
        <PreviewImage
          file={previewImage}
          label={label}
          onClick={() => {
            setPreviewImage('');
            setFieldValue('image', '');
          }}
        />
      ) : (
        <UploadImage
          required={required}
          onChange={handleChange}
          name={'image'}
          label={label}
          setFieldValue={setFieldValue}
        />
      )}
    </>
  );
};

export default React.memo(ImageUploadWithPreview);
